import { Flex } from '@/components/base';

import HomeNegativeFeedback from './home-negative-feedback';
import HomeTopSignals from './home-top-signals';

const HomeFeedbackTrends = () => {
  return (
    <Flex g={24}>
      <Flex f={6}>
        <HomeTopSignals />
      </Flex>
      <Flex f={6}>
        <HomeNegativeFeedback />
      </Flex>
    </Flex>
  );
};

export default HomeFeedbackTrends;
